<script>
	import loadjs from 'loadjs'
	import { onMount } from 'svelte'

	const jq = window.$

	export let coordinates
	// export let locations

	function generateMap(mapEl) {
		loadjs(
			[
				'/wp-content/themes/casana-theme/assets/css/mapbox-gl.min.css',
				'/wp-content/themes/casana-theme/assets/js/mapbox-gl.min.js'
			],
			() => {
				const { mapboxgl } = window
				let [lng, lat] = coordinates

				mapboxgl.accessToken =
					'pk.eyJ1IjoiamdhbnN0ZiIsImEiOiJjbGh6ZmxlbG8wcmhhM2xuNWk5bHl4NXVuIn0.5zoMvRvsBVyxEuke2pDIag'

				// init map
				//window.
				let map = new mapboxgl.Map({
					container: mapEl, //'map-wrap',
					style:
						'mapbox://styles/jganstf/clhz0ptkv008701pva8ql892e?optimize=true',
					center: [lng, lat],
					zoom: 11,
				})

				// add marker
				let curMarker = document.createElement('div')
				curMarker.className = 'location-marker'
				let tmp = new mapboxgl.Marker(curMarker)
					.setLngLat([lng, lat])
					.addTo(map)
				curMarker.removeAttribute('aria-label')

				// add scale control
				//map.addControl(new mapboxgl.NavigationControl())

				// disable map zoom when using scroll
				map.scrollZoom.disable()
			}
			,{
				async: true,
			}
		)
	}

	let mapContainer
	onMount(() => {
		generateMap(mapContainer)

		// window.onresize = function() {
		//   console.log('resizing')
		// }
	})
</script>

<div class="map-wrap" bind:this={mapContainer} />
